module.exports = __webpack_public_path__ + "img/chart2.513b0459.png";